angular.module('serviceArea', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate', 'uiGmapgoogle-maps']);



// WEBPACK FOOTER //
// ./src/app/service/area/area.module.js